// ColumnDefinition.ts
import {
  makeUniqueIDForFieldConf
} from "@adornis/field-management/field-configuration.js";
function buildFullColumnDefinition(colDef, options, fieldConf) {
  const resizable = colDef.isResizable ?? options.isColumnResizable ?? false;
  return {
    ...colDef,
    _id: fieldConf?._id ? fieldConf?._id : makeUniqueIDForFieldConf({ customID: colDef.customID ?? void 0, fieldName: colDef.fieldName ?? void 0 }),
    columnWidth: resizable ? fieldConf?.columnWidth ?? colDef.columnWidth ?? "1fr" : colDef.columnWidth ?? "1fr",
    isSortable: colDef.isSortable ?? false,
    columnName: colDef.columnName ?? null,
    isAlwaysVisible: colDef.isAlwaysVisible ?? false,
    isResizable: resizable,
    isSticky: colDef.isSticky ?? false
  };
}
export {
  buildFullColumnDefinition
};
